import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

import { API_BASE_URL } from '../config/api';

function Banner() {
  const location = useLocation();
  const [bannerHtml, setBannerHtml] = useState('');

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/config`);
        if (response.data.success) {
          const headerBanner = response.data.data.headerBanner;
          if (headerBanner && headerBanner.trim()) {
            setBannerHtml(headerBanner);
          }
        }
      } catch (err) {
        console.error('Error loading banner config:', err);
      }
    };
    fetchConfig();
  }, []);

  // Process HTML content to replace relative API paths with absolute URLs
  // This ensures images and other assets work in both development and production
  const processBannerContent = (content) => {
    if (!content) return '';
    
    // In production, relative paths work fine since API and frontend are on same origin
    // In development, we need to convert relative /api/ paths to absolute URLs
    if (process.env.NODE_ENV === 'production') {
      return content; // No processing needed in production
    }
    
    // Replace relative /api/ paths with full API_BASE_URL for development
    // API_BASE_URL is like "http://localhost:3005/api"
    // We want to replace /api/content/image.jpg with http://localhost:3005/api/content/image.jpg
    let processed = content.replace(
      /(src|href)=["'](\/api\/[^"']+)["']/gi,
      (match, attr, path) => {
        // If path already starts with http:// or https://, don't modify it
        if (path.startsWith('http://') || path.startsWith('https://')) {
          return match;
        }
        // Convert relative /api/ path to absolute URL using API_BASE_URL
        // API_BASE_URL already includes /api, so we can use it directly
        return `${attr}="${API_BASE_URL}${path.replace('/api', '')}"`;
      }
    );
    
    return processed;
  };

  // Don't show banner on admin or login pages
  if (location.pathname === '/admin' || location.pathname === '/login') {
    return null;
  }

  // Don't render if no content
  if (!bannerHtml || !bannerHtml.trim()) {
    return null;
  }

  const processedHtml = processBannerContent(bannerHtml);

  return (
    <div className="w-full bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <style>{`
          .banner-content img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 0 auto;
          }
        `}</style>
        <div 
          className="banner-content"
          dangerouslySetInnerHTML={{ __html: processedHtml }}
        />
      </div>
    </div>
  );
}

export default Banner;
